import React, { useCallback, useState } from 'react';
import axios from 'axios';
import { useDropzone } from 'react-dropzone';
import { Card } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage, faSpinner, faTimes } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import Button from '../../../shared/button';

export default function CaUpload({
  acceptedFileTypes,
  caUrl,
  icon,
  uploadedAgo,
  uploadedFile,
  onFileRemove,
  onFileUploaded
}) {
  const [isUploadingFile, setIsUploadingFile] = useState(false);

  const onDrop = useCallback((acceptedFiles) => {
    setIsUploadingFile(true);
    const formData = new FormData();
    formData.append('upload[file]', acceptedFiles[0]);
    return axios.post('/uploads', formData)
      .then(({ data }) => onFileUploaded(data))
      .finally(() => setIsUploadingFile(false));
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: acceptedFileTypes,
    maxFiles: 1,
    disabled: isUploadingFile
  });

  if (uploadedFile) {
    return (
      <Card>
        <Card.Body className="p-4 d-flex align-items-center justify-content-center gap-3">
          <div className="flex-1 text-right"><FontAwesomeIcon icon={icon} size="2x"/></div>
          <div className="d-flex align-items-center justify-content-center gap-2 flex-column">
            <h4 className="m-0">
              <a href={caUrl} rel="noopener noreferrer" target="_blank">
                <strong>{uploadedFile}</strong>
              </a>
            </h4>
            <div className="text-muted">Uploaded {uploadedAgo}</div>
          </div>
          <div className="flex-1">
            <Button.Danger icon={faTimes} plain onClick={onFileRemove}>Remove</Button.Danger>
          </div>
        </Card.Body>
      </Card>
    );
  }

  let dropzoneMarkup = {
    text: 'Drag File, or click here to upload',
    icon: faImage,
    spin: false,
  };
  if (isUploadingFile) {
    dropzoneMarkup = {
      text: 'Uploading file...',
      icon: faSpinner,
      spin: true,
    };
  } else if (isDragActive) {
    dropzoneMarkup = {
      text: 'Drop your CA here',
      icon: faImage,
    };
  }

  return (
    <Card className="clickable border-dashed" {...getRootProps()}>
      <Card.Body className="p-4">
        <input {...getInputProps()} />
        <h4 className={`gap-2 d-flex align-items-center justify-content-center text-muted`}>
          <FontAwesomeIcon icon={dropzoneMarkup.icon} size="lg" spin={dropzoneMarkup.spin}/>
          {dropzoneMarkup.text}
        </h4>
      </Card.Body>
    </Card>
  );
}

CaUpload.propTypes = {
  acceptedFileTypes: PropTypes.array.isRequired,
  caUrl: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired,
  uploadedAgo: PropTypes.string,
  uploadedFile: PropTypes.string,
  onFileRemove: PropTypes.func.isRequired,
  onFileUploaded: PropTypes.func.isRequired
};
